import { render, staticRenderFns } from "./QueryRiver.vue?vue&type=template&id=6424c9af&scoped=true&"
import script from "./QueryRiver.vue?vue&type=script&lang=js&"
export * from "./QueryRiver.vue?vue&type=script&lang=js&"
import style0 from "./QueryRiver.vue?vue&type=style&index=0&id=6424c9af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6424c9af",
  null
  
)

export default component.exports